import { lazy } from 'react';
import Home from '../screens/Home';
import Login from '../screens/Login';
import Dashboard from '../screens/Dashboard';
const Orders = lazy(() => import('../screens/Orders'));
const Products = lazy(() => import('../screens/Products'));
const Customers = lazy(() => import('../screens/Customers'));
const Suppliers = lazy(() => import('../screens/Suppliers'));
const Settings = lazy(() => import('../screens/Settings'));
const Logistics = lazy(() => import('../screens/Logistics'));
const Transactions = lazy(() => import('../screens/Transactions'));
const Unauthorized = lazy(() => import('../screens/Unauthorized'));

const routes = [
  {
    path: '',
    component: Dashboard,
    name: 'Dashboard Page',
    protected: true,
  },
  {
    path: '/home',
    component: Home,
    name: 'Home Page',
    protected: true,
  },
  {
    path: '/orders',
    component: Orders,
    name: 'Orders Page',
    protected: true,
    requiredPermission: 'orders.read',
  },
  {
    path: '/products',
    component: Products,
    name: 'Products Page',
    protected: true,
    requiredPermission: 'products.read',
  },
  {
    path: '/suppliers',
    component: Suppliers,
    name: 'Suppliers Page',
    protected: true,
    requiredPermission: 'suppliers.read',
  },
  {
    path: '/customers',
    component: Customers,
    name: 'Customers Page',
    protected: true,
    requiredPermission: 'customers.read',
  },
  {
    path: '/settings',
    component: Settings,
    name: 'Settings Page',
    protected: true,
    requiredPermission: 'settings.read',
  },
  {
    path: '/logistics',
    component: Logistics,
    name: 'Logistics Page',
    protected: true,
    requiredPermission: 'transactions.read',
  },
  {
    path: '/transactions',
    component: Transactions,
    name: 'Transactions Page',
    protected: true,
    requiredPermission: 'transactions.read',
  },
  {
    path: '/login',
    component: Login,
    name: 'Login Screen',
    protected: false,
  },
  {
    path: '/unauthorized',
    component: Unauthorized,
    name: 'Unauthorized Screen',
    protected: false,
  },
];

export default routes;
